(() => {
  const DESKTOP = window.matchMedia('(min-width: 990px)');
  const THRESHOLD = 100;
  const CLASS_NAME = 'tmm-menu-only';

  const setHeightVar = () => {
    // Try to measure the Qikify menu height so body padding matches it
    const menu =
      document.querySelector('.qikify-smartmenu') ||
      document.querySelector('.qikify-megamenu') ||
      document.querySelector('[class*="qikify"][class*="menu"]') ||
      document.querySelector('[id*="qikify"]');

    if (!menu) return;
    const h = Math.round(menu.getBoundingClientRect().height) || 56;
    document.documentElement.style.setProperty('--tmm-qikify-h', `${h}px`);
  };

  const update = () => {
    const onDesktop = DESKTOP.matches;
    const active = onDesktop && window.scrollY > THRESHOLD;

    document.documentElement.classList.toggle(CLASS_NAME, active);

    if (active) setHeightVar();
  };

  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', () => { setHeightVar(); update(); });

  // Qikify can load late; watch DOM changes briefly
  const obs = new MutationObserver(() => {
    setHeightVar();
    update();
  });
  obs.observe(document.documentElement, { subtree: true, childList: true });

  update();
})();
